import { jsx, jsxs } from 'react/jsx-runtime';
import * as React from 'react';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import styles from '../../styles/uitk-egds-list.css';
import EGDSListContext from '../list/index.esm.js';
import { EGDSListOrientations, EGDSListSizes, EGDSListItemThemes, EGDSListBullets } from '../types/index.esm.js';
import { classNames } from '../../utils/classnames/index.esm.js';
const getClassNameList = classNames.bind(styles);
const EGDSListItem = props => {
  const {
    children,
    theme = 'default',
    ...attributes
  } = props;
  const context = React.useContext(EGDSListContext);
  const {
    bullet,
    orientation,
    size,
    type,
    indent
  } = context;
  const bulletClass = () => {
    // If bullet is default, set type as bullet style
    // if bullet is not default, set bullet as bullet style
    let value;
    if (bullet && type) {
      value = EGDSListBullets.get(bullet) === 'bullet-default' ? `bullet-${type}` : EGDSListBullets.get(bullet);
    }
    return value;
  };
  const baseClass = 'uitk-typelist-item'; // Temporary: name clash with menu
  const bulletBaseClass = `${baseClass}-bulletchar`;
  const wrapperClassNames = getClassNameList(baseClass, `${baseClass}-${bulletClass()}`, bullet && bullet.includes('icon') && `${baseClass}-bullet-icon`, orientation && `${baseClass}-${EGDSListOrientations.get(orientation)}`, size && `${baseClass}-${EGDSListSizes.get(size)}`, bullet && !bullet.includes('icon') && `${baseClass}-${EGDSListItemThemes.get(theme)}`, bullet && bullet.includes('icon') && theme && `${baseClass}-bullet-icon-${EGDSListItemThemes.get(theme)}`, indent ? `${baseClass}-indent` : `${baseClass}-no-indent`);
  const bulletCssClassNames = getClassNameList(bulletBaseClass, `${bulletBaseClass}-${bulletClass()}`, size && `${bulletBaseClass}-${EGDSListSizes.get(size)}`);
  const displayChildren = React.Children.toArray(children).map((child, index) => child?.type?.displayName?.match(/(EGDS|Uitk)Icon/) ? jsx("div", {
    className: getClassNameList(`${baseClass}-icon`),
    children: child
  }, `list-item-${index}`) : child);
  // Set bullet markup?
  const bulletMarkup = bullet && (EGDSListBullets.get(bullet) === 'bullet-default' || EGDSListBullets.get(bullet) === 'bullet-tiered-numbered') ? jsx("span", {
    "aria-hidden": "true",
    className: bulletCssClassNames
  }) : null;
  // Wrap children to make grid layout to work as expected with bullet markup
  const wrappedChildren = bulletMarkup ? jsx("span", {
    className: getClassNameList(`${baseClass}-child`),
    children: displayChildren
  }) : displayChildren;
  return displayChildren ? jsxs("li", {
    className: wrapperClassNames,
    ...attributes,
    children: [bulletMarkup, wrappedChildren]
  }) : null;
};
EGDSListItem.displayName = 'EGDSListItem';
export { EGDSListItem };